<template>
  <button @click="toggleFollow" :class="{ 'is-following': isFollowing }">
    {{ isFollowing ? 'Unfollow' : 'Follow' }}
  </button>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    userId: {
      type: Number,
      required: true
    },
    initialIsFollowing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFollowing: this.initialIsFollowing
    }
  },
  methods: {
    async toggleFollow() {
      try {
        const url = this.isFollowing 
          ? `/unfollow/${this.userId}`
          : `/follow/${this.userId}`;
        
        const response = await axios.post(url);
        
        if (response.data.success) {
          this.isFollowing = !this.isFollowing;
        }
      } catch (error) {
        console.error('Error toggling follow:', error);
      }
    }
  }
}
</script>

<style scoped>
button {
  padding: 5px 10px;
  border: 1px solid #007bff;
  background-color: #fff;
  color: #007bff;
  cursor: pointer;
}

button.is-following {
  background-color: #007bff;
  color: #fff;
}
</style>